module.exports = __webpack_public_path__ + "static/media/facebook_us.d15e0fd0.png";